<template>
  <div
    id="top-nav"
    class="w-full h-12 fixed top-0 flex flex-row lg:shadow-sm justify-between bg-white z-40 border-b"
  >

    <section class="flex items-center justify-between">
      <!-- HAMBURGER MENU (UP UNTIL MD) -->
      <div
        v-if="getActiveSite !== null && path !== '/sitemap'"
        class="flex justify-start items-center lg:hidden"
      >
        <button @click="TOGGLE_MOBILEMENU()" class="w-8 ml-4 focus:outline-none focus:bg-gray-light dark:focus:bg-gray-600 rounded mt-1 relative">
          <font-awesome-icon icon="fa-regular fa-bars" class="w-7 h-7 p-0.5" />
          <div v-if="totalNotifications > 0" class="absolute top-0.5 right-0 fadein rounded-full bg-red-500 p-1.5 shadow" />
        </button>
      </div>

      <!-- CRUZ CONTROL LOGO -->
      <div v-if="(getActiveSite !== null || noSiteAccess) && screen.sm" class="flex">
        <router-link to="/" @click="handleLogoClick" class="flex items-center w-full mx-auto">
          <img :src="headerLogo" alt="CruzControl" class="h-9 md:h-12 py-0.5 md:py-1 px-4 lg:pr-8">
        </router-link>
      </div>

      <!-- SITEMAP HEADER LOGO -->
      <div v-else-if="path == '/sitemap'" class="flex items-center w-full mx-auto">
        <img :src="headerLogo" alt="CruzControl" class="h-9 md:h-12 py-0.5 md:py-1 px-4 lg:px-8">
      </div>

    </section>

    <!-- ACTIVE SITE INDICATOR (SM AND UP) -->
    <div
      v-if="getActiveSite && path !== '/sitemap' && screen.sm"
      class="site-indicator"
    >
      <h3 class="site-indicator__name">
        {{ getActiveSite.name }}
      </h3>
      <span class="site-indicator__divider">·</span>
      <h3 class="site-indicator__address">
        <font-awesome-icon icon="fa-solid fa-location-dot" class="site-indicator__icon" />
        {{ getActiveSite.address }}
      </h3>
    </div>

    <div v-else-if="getActiveSite && path !== '/sitemap' && !screen.sm" class="flex items-center mx-auto">
      <div class="w-full">
        <router-link to="/sitemap">
          <h3 class="text-sm font-bold text-gray-900 dark:text-gray-300 uppercase truncate px-2">
            <font-awesome-icon icon="fa-solid fa-location-dot" class="text-gray-dark dark:text-gray-400 mr-1" />
            {{ getActiveSite.name }}
          </h3>
        </router-link>
      </div>
    </div>

    <!-- PROFILE ICON -->
    <div
      v-if="path !== '/sitemap' && (getActiveSite !== null || noSiteAccess)"
      class="mr-6 justify-end items-center flex"
    >
      <UserDropdownComponent @toggle-menu="toggleMenu" />
    </div>

  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex"
import UserDropdownComponent from "@/components/UserDropdownComponent.vue"

const LOGO_DARK = '/CruzControl_Logo_Small_Icon.svg'
const LOGO_LIGHT = '/CruzControl_Logo_Small_Icon_Light.svg'

export default {
  name: "CruzHeader",
  components: {
    UserDropdownComponent,
  },
  data() {
    return {
      openedDropdown: false
    }
  },
  computed: {
    ...mapState([
      "sideMenuVisible",
      "active_site",
      "noSiteAccess",
      "screen"
    ]),
    ...mapGetters([
      "getEmployeeSites",
      "getActiveSite",
      "getUserId",
      "totalNotifications",
      "getTheme"
    ]),
    headerLogo() {
      return this.getTheme === 'dark' ? LOGO_DARK : LOGO_LIGHT
    },
    path() {
      return this.$route.path
    },
  },
  methods: {
    ...mapMutations([
      "TOGGLE_MOBILEMENU",
    ]),
    handleLogoClick() {
      window.scrollTo(0, 0)
    },
    toggleMenu(bool) {
      setTimeout(() => {
        this.openedDropdown = bool
      }, bool ? 0 : 100)
    }
  },
}
</script>

<style scoped>
.site-indicator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: auto;
  margin-right: 0.625rem;
  overflow: hidden;
  white-space: nowrap;
  justify-content: flex-end;
}

.site-indicator__name {
  font-size: 0.8125rem;
  font-weight: 700;
  color: #151e38;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  flex-shrink: 0;
}

.site-indicator__divider {
  color: #c1c2be;
  font-size: 1rem;
  line-height: 1;
  flex-shrink: 0;
}

.site-indicator__address {
  font-size: 0.6875rem;
  font-weight: 500;
  color: #81827f;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.site-indicator__icon {
  color: #c1c2be;
  margin-right: 0.25rem;
  font-size: 0.625rem;
}

[data-theme="dark"] #top-nav {
  background: var(--cc-nav);
  border-color: var(--cc-nav-border);
  /* backdrop-filter: blur(16px) saturate(150%); */
}
[data-theme="dark"] #top-nav::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(16px) saturate(150%);
  border-color: var(--cc-nav-border);
  z-index: -1; /* Keep it behind the nav content */
}
</style>
